export default "__VITE_ASSET__CNHuetG9__"